import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  AddToCollaborationPayload,
  DeleteMessagePayload,
  InitUnreadCollaborationsPayload,
  ReadCollaborationPayload,
  ReceiveMessagePayload,
  ThumbnailReadyPayload,
} from '../../services/gateways/interfaces';
import { collaborationsStateKey } from './collaborations.state-key';

export const collaborationsActions = createActionGroup({
  source: collaborationsStateKey,
  events: {
    WsReceiveMessage: props<{ data: ReceiveMessagePayload }>(),
    WsDeleteMessage: props<{ data: DeleteMessagePayload }>(),
    WsThumbnailReady: props<{ data: ThumbnailReadyPayload }>(),
    WsAddToCollaboration: props<{ data: AddToCollaborationPayload }>(),
    WsReadCollaboration: props<{ data: ReadCollaborationPayload }>(),
    WsInitUnreadCollaborations: props<{ data: InitUnreadCollaborationsPayload }>(),
    WsConnectionEstablished: emptyProps(),
    WsConnectionClosed: emptyProps(),
    WsConnectionError: emptyProps(),

    CollaborationBecameUnread: props<{ collaborationId: string; siteId: string }>(),
    ScreenRecordingRequested: props<{
      collaborationId: string;
      siteId: string;
      patientId?: string;
    }>(),
    ScreenRecordingStopRequested: emptyProps(),
    ScreenRecordingSucceeded: props<{ file: File }>(),
  },
});
